import React, {PropTypes} from 'react';


function AddContact(props) {
  const {
    className,
    width = 32,
    height = 30,
    viewBox = '7 7 23 22',
    border = false,
    fillColor='#4a4a4a',
    ...otherProps
  } = props;

  return (
    <svg width={`${width}px`} height={`${height}px`} viewBox={`${viewBox}`} version='1.1' xmlns='http://www.w3.org/2000/svg' className={`add-contact-icon ${className}`} {...otherProps}>
      <g id="----3335---Adding-A-Contact-Through-Worksheet" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="3335---SO---Company-Workshet---Add-A-Contact-1" transform="translate(-1186.000000, -166.000000)">
              <g id="Group-9" transform="translate(1186.000000, 166.000000)">
                  {
                    border
                    &&
                    <g id="Group-54-Copy" fill={`${fillColor}`}>
                        <path d="M15.55,30 C6.97573,30 0,23.271 0,15 C0,6.729 6.97573,0 15.55,0 C24.12427,0 31.1,6.729 31.1,15 C31.1,23.271 24.12427,30 15.55,30 L15.55,30 Z M15.55,2 C8.11917333,2 2.07333333,7.832 2.07333333,15 C2.07333333,22.168 8.11917333,28 15.55,28 C22.9808267,28 29.0266667,22.168 29.0266667,15 C29.0266667,7.832 22.9808267,2 15.55,2 L15.55,2 Z" id="Shape"></path>
                    </g>
                  }
                  <g id="Group-22" transform="translate(8.000000, 9.000000)">
                      <g id="Group-53">
                          <path d="M14.5,11 L0.5,11 C0.225,11 0,10.7736798 0,10.4970662 L0,2.50293378 C0,2.2263202 0.225,2 0.5,2 L14.5,2 C14.775,2 15,2.2263202 15,2.50293378 L15,10.4970662 C15,10.7736798 14.775,11 14.5,11 Z" id="Shape" stroke={`${fillColor}`} strokeWidth="1.5"></path>
                          <path d="M15,2 C14.3735,3.46137124 12.5835,5 10.887,5 L4.113,5 C2.433,5 0.6365,3.48394649 0,2.0451505" id="Shape" stroke={`${fillColor}`} strokeWidth="1.5"></path>
                          <path d="M5,2 L5,0.25 C5,0.1815 5.035,0.119 5.091875,0.0735 C5.14875,0.028 5.226875,0 5.3125,0 L7.5,0 L9.6875,0 C9.77375,0 9.851875,0.028 9.908125,0.0735 C9.965,0.1185 10,0.181 10,0.25 L10,2" id="Shape" stroke={`${fillColor}`} strokeWidth="1.5"></path>
                          <g id="Group-37" transform="translate(9.000000, 6.000000)">
                              <ellipse id="Oval-Copy-5" fill="#FAFAFA" cx="5" cy="5" rx="5" ry="5"></ellipse>
                              <path d="M2.14285714,5 L7.85714286,5" id="Shape" stroke={`${fillColor}`} strokeWidth="2"></path>
                              <path d="M5,2.14285714 L5,7.85714286" id="Shape" stroke={`${fillColor}`} strokeWidth="2"></path>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </g>
    </svg>
  );
}


AddContact.propTypes = {
  className: PropTypes.string
};

export default AddContact;



// WEBPACK FOOTER //
// ./shared/common/svgs/AddContact/index.js